import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: (props) => ({
    width: "100%",
    background: theme.palette.background.paper,
    borderRadius: 8,
    marginTop: 16,
    "& .MuiTableRow-root": {
      backgroundColor: props?.isDarkMode
        ? theme.palette.background.primary
        : "inherit",
    },
    "& .MuiTableRow-hover:hover": {
      backgroundColor: props?.isDarkMode ? "#1c2028" : "#0000000a",
    },
    "&  .MuiTable-root": {
      position: "absolute",
    },
  }),
}));
